import React, { Component } from 'react';
import {
    Modal, ChoiceList, Button
} from "@shopify/polaris";
import { reqPostAgreement } from '../../../../../api';
import './index.css'
import intl from '../../../../../i18n/intl'
import utils from '../../../../../utils/utils';
class AgreementModal extends Component {
    state = {
        agreement: false,
        selectedExport: [],
        agreementLight: false
    }

    UNSAFE_componentWillReceiveProps = (prev) => {
        if (prev.agreement) {
            let showFlag = prev.agreement;
            let lastTime = utils.getStore('agreement_time') || window.agreement_time;

            if (lastTime) {
                let nowTime = new Date().getTime();
                lastTime = Number(lastTime) ? Number(lastTime) : 0;
                if (nowTime < lastTime) {
                    showFlag = false;
                }
            }

            this.setState({ agreement: showFlag });
        }
    }

    handleModalCloseOk = async () => {
        if (this.state.selectedExport.length >= 1) {
            this.setState({
                agreement: !this.state.agreement
            })
            return await reqPostAgreement()
        } else {
            this.setState({
                agreementLight: true
            })
        }
    };

    handleModalClose = async () => {
        this.setState({
            agreement: !this.state.agreement
        }, () => {
            if (!this.state.agreement) {
                window.agreement_time = new Date().getTime() + 86400 * 1000;
                utils.setStore('agreement_time', new Date().getTime() + 86400 * 1000);
            }
        })
    };

    handleSelectedExport = (value) => {
        this.setState({
            selectedExport: value
        })
    };

    render() {
        const CURRENT_PAGE = 'I accept this agreement';
        const { agreement, agreementLight, selectedExport } = this.state
        return (
            <div>
                <Modal
                    open={agreement}
                    onClose={this.handleModalClose}
                >
                     <Modal.Section>
                    <div className="_agreement_box">
                        <h2 className="_agreement_h">{intl.get("Dropshipman User Agreement")}</h2>
                        <p className="_agreement_p">
                            {intl.get('In order to better serve our customers and establish a good cooperative relationship between customers and the platform, please read and sign the following agreement to confirm that it is an authorization agreement. All disputes encountered after that will be handled according to the content of the agreement. , you can send an email for consultation.In order to better serve our customers and establish a good cooperative relationship between customers and the platform, please read and sign the following agreement to confirm that it is an authorization agreement. All disputes encountered after that will be handled according to the content of the agreement. , you can send an email for consultation.In order to better serve our customers and establish a good cooperative relationship between customers and the platform.')}
                        </p>
                        <div className="agreement_accept">
                            <ChoiceList
                                choices={[
                                    {
                                        label: <span style={{
                                            color: agreementLight ? 'blue' : '#202223'
                                        }}>{intl.get('I accept this agreement')}</span>, value: CURRENT_PAGE
                                    },
                                ]}
                                selected={selectedExport}
                                onChange={this.handleSelectedExport}
                            />
                            <Button primary onClick={this.handleModalCloseOk}>{intl.get('OK')}</Button>
                        </div>
                    </div>
                    </Modal.Section>
                </Modal>
            </div>
        );
    }
}

export default AgreementModal;
